import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../services/firebase-init';
import calendarDayNoteService from '../services/calendar-day-note-service';

const CalendarDayNoteContext = createContext();
export function useCalendarDayNoteContext() { return useContext(CalendarDayNoteContext); }

export function CalendarDayNoteProvider({ children }) {
  const [dayNotes, setDayNotes] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      if (user) {
        calendarDayNoteService.startListener((updatedNotes) => {
          setDayNotes(updatedNotes);
          setLoading(false);
        });
      } else {
        calendarDayNoteService.stopListener();
        setDayNotes({});
        setLoading(false);
      }
    });
    return () => { unsub(); calendarDayNoteService.stopListener(); };
  }, []);

  const value = { dayNotes, loading, calendarDayNoteService };
  return <CalendarDayNoteContext.Provider value={value}>{children}</CalendarDayNoteContext.Provider>;
}
